// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"89ce2db2","239":"a1fc5c39","644":"bd4836c2","749":"86bea771","869":"58fd3146","903":"b779bafb","959":"32e7ec11"}[chunkId] + ".chunk.js";
};